import { NgModule } from '@angular/core';
import { provideSvgIcons } from '@ngneat/svg-icon';
import { flinkIconSet } from '.';

@NgModule({
  providers: [provideSvgIcons(flinkIconSet)]
})
export class FlinkIconsModule {}
